export default "__VITE_ASSET__CV$Q1Uzj__"